import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { navBarColor } from '../Themes/themeColorConfig';
import { Email,Phone } from '@mui/icons-material';

export default function ContactModal({ contactModalOpen, setContactModalOpen, restaurant }) {


    const modalColors = new navBarColor();


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor:  modalColors.bg,
        // border: '2px solid #000',
        boxShadow: 24,
        borderRadius:1,
        p: 4,
        textAlign: 'center'
    };


    const [btns, setBtns] = useState([
        { 'id': 1, "name": "Email",'icon':<Email/> },
        { 'id': 2, "name": "Phone Number", 'icon':<Phone/> },
    ])

    return (
        <div>
            <Modal
                open={contactModalOpen}
                onClose={() => setContactModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: 2, color:modalColors.text }}>
                        Contact Us
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        {btns.map((items) => {
                            return (
                                <Button
                                startIcon={items.icon}
                                    variant='outlined'
                                    href={items.name === "Email" ? `mailto:${restaurant.email}` : `tel:${restaurant.phone}`}
                                    sx={{
                                        color:modalColors.text,
                                        borderColor:modalColors.text,
                                        width: '45%',
                                        height: '50px'
                                    }}
                                >{items.name}</Button>
                            )
                        })}
                    </Box>
                </Box>
            </Modal>
        </div>
    );
}
